<template>
  <div
    class="products-list"
    ref="productsList"
  >
    <product-list-item
      v-for="product in PRODUCTS"
      :key="product.id"
      :product="product"
    />
    <div class="products-list-loader"
      v-if="!END"
      v-reached="load"
    >
      <transition name="fade">
        <ui-loader size="60" v-if="PROGRESS" />
      </transition>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

/* Components */
import productListItem from './product-list-item';
import UiLoader from '../kit/ui-loader/ui-loader.vue';

export default {
  name: 'products-list',

  components: {
    productListItem,
    UiLoader,
  },

  computed: {
    ...mapGetters({
      PRODUCTS: 'category/products',
      PROGRESS: 'category/loadProgress',
      END: 'category/end',
    }),
  },

  methods: {
    ...mapActions({
      LOAD_DATA: 'category/loadData',
    }),
    load() {
      if (this.END || this.PROGRESS) {
        return;
      }
      this.LOAD_DATA();
    }
  },
}
</script>

<style lang="scss">
.products-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
  grid-row-gap: 20px;
  width: 100%;
  margin-top: 24px;

  &-loader {
    grid-column: 1 / 3;
    display: flex;
    justify-content: center;
    color: $blue;
  }
}

@include breakpoint("tablet") {
  .products-list {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-row-gap: 32px;
    &-loader {
      grid-column: 1 / 5;
    }
  }
}

@include breakpoint("desktop") {
  .products-list {
    margin-top: 48px;
    grid-column-gap: 24px;
    grid-row-gap: 48px;
  }
}

</style>
